export default {
  login: {
    txt1: "Verifikasi Kode Rahasia dalam game",
    txt2: "Silakan Masukkan Kode Misterius",
    txt3: "Verifikasi",
    txt4: "Silakan Memilih Server Anda",
    txt5: "Silakan Memilih UID Anda",
    txt6: "Login",
    txt7: "Pusat Bantuan",
  },
  nav: {
    txt1: "Beranda",
    txt2: "Live Stream",
    txt3: "Ranking",
    txt4: "MVP",
    txt5: "Hadiah\nMenonton",
    txt6: "Hadiah\nLive Stream",
    txt7: "Hadiah",
    txt8: "Content\nCreator",
  },
  live: {
    txt1: "Jadwal Pertandingan",
    txt2: "Live Stream lainnya",
    txt3: "Waktu: ",
    txt4: "Konten: ",
    txt5: "Masuk",
    txt6: "Waktu",
    txt7: "Pertandingan",
    txt8: "Selamat Datang, Silakan Log-in",
  },
  process: {
    nav1: "Peringkat Babak Kualifikasi",
    nav3: "Peringkat\nPoin Total",
    nav2: "Diagram Babak\nEliminasi",
    txt1: "Ranking",
    txt2: "Nama Tim	",
    txt3: "Server",
    txt4: "Poin",
    txt5: "Divisi",
    txt6: "Kills",
    list: ["Divisi I", "Divisi II", "Divisi III", "Divisi IV"],
    img: require("@/assets/in-img.jpg"),
  },
  periphery: {
    time1: "2023/11/22",
    title1: "Giveaway #1: Semifinals Gift Code l",
    time2: "2023/11/24",
    title2: "Giveaway #2: Semifinals Gift Code ll",
    time3: "2023/11/25",
    title3: "Giveaway #3: Championship Gift Code",
    p1: "Wager Token",
    p2: "Diamond ",
    p3: "Guild Token Chest ",
    p4: "Large Zeny Chest ",
    p5: "Rare Card Coupon ",
    p6: "Refining & Enchanting Pack II",
  },
  mvp: {
    txt1: "Skor Tertinggi",
    txt2: "Server",
    txt3: "Nama Tim",
    txt4: "IGN",
    txt5: "Level",
    txt6: "Job",
    txt7: "Babak Elimasi Top 32",
    txt8: "Babak Grand Final",
  },
  task: {
    loginTip:"Petualang, silakan Log-in dan menyelesaikan misi sebelum mengkalim hadiah~",
    reward830: "Delot Opt. Pack *10\nNebula Path Material *50",
    task830: "Akumulasi nonton 10 menit pada 30 Agustus",
    reward91: "Ash of Delot *300\n Nebula Path Material *50",
    task91: "Akumulasi nonton 10 menit pada 1 September",
    reward92: "Precious Sigil Pack *10\n Nebula Path Material *100",
    task92: "Akumulasi nonton 10 menit pada 2 September",
    reward94: "Soul Crystal Random Box III *3\nNebula Path Material *100",
    task94: "Akumulasi nonton 15 menit pada 4 September",
    reward96: "Soul Crystal Random Box III *3\nNebula Path Material *100",
    task96: "Akumulasi nonton 15 menit pada 6 September",
    reward98:
      "Soul Crystal Key III *1  Soul Crystal Key II *1\nFlawed Sigil Crystal *10",
    task98: "Akumulasi nonton 15 menit pada 8 September",
    rewardTotal2: "Enchanting Coin Opt. Chest *2\nEnchanting Ticket *100",
    taskTotal2: "Quest menonton 2 pertandingan",
    rewardTotal5: "Badge of Dusk *1 Gacha Ticket *5\n Super Pet Coupon *5",
    taskTotal5: "Quest menonton 5 pertandingan",
    txt7: "Sedang berlangsung",
    txt8: "Sedang berlangsung",
    txt9: "Detail",
    txt10: "Klaim",
    txt11: "已领取",
  },
  reward: [
    {
      type: "Babak Eliminasi",
      item: [
        {
          name: "1",
          image: require("@/assets/en-re1.png"),
          imageM: require("@/assets/mobile/en-re1.png"),
          list: [
            {
              name: "Thor Cup Champion Mount",
              amount: "",
            },
            {
              name: "Title: Thor Cup Champion (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Champion",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Champion",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "20000",
            },
            {
              name: "Diamond",
              amount: "5000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "10",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "30",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "40",
            },
            {
              name: "Crest of Moon",
              amount: "8",
            },
            {
              name: "King Statue Chest",
              amount: "10",
            },
          ],
        },
        {
          name: "2",
          image: require("@/assets/en-re2.png"),
          imageM: require("@/assets/mobile/en-re2.png"),
          list: [
            {
              name: "Title: Thor Cup 2nd Place (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup 2nd Place",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Runner-up",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "10000",
            },
            {
              name: "Diamond",
              amount: "4500",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "10",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "25",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "36",
            },
            {
              name: "Crest of Moon",
              amount: "6",
            },
            {
              name: "King Statue Chest",
              amount: "8",
            },
          ],
        },
        {
          name: "3~4",
          image: require("@/assets/en-re3.png"),
          imageM: require("@/assets/mobile/en-re3.png"),
          list: [
            {
              name: "Title: Thor Cup Top 4 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 4",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 4",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "17",
            },
            {
              name: "Nyan Berry",
              amount: "5000",
            },
            {
              name: "Diamond",
              amount: "4000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "8",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "20",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "32",
            },
            {
              name: "Crest of Moon",
              amount: "4",
            },
            {
              name: "King Statue Chest",
              amount: "6",
            },
          ],
        },
        {
          name: "5~8",
          image: require("@/assets/en-re4.png"),
          imageM: require("@/assets/mobile/en-re4.png"),
          list: [
            {
              name: "Title: Thor Cup Top 8 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 8",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 8",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "15",
            },
            {
              name: "Nyan Berry",
              amount: "3000",
            },
            {
              name: "Diamond",
              amount: "3000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "6",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "15",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "28",
            },
            {
              name: "Crest of Moon",
              amount: "3",
            },
            {
              name: "King Statue Chest",
              amount: "4",
            },
          ],
        },
        {
          name: "9~16",
          image: require("@/assets/en-re5.png"),
          imageM: require("@/assets/mobile/en-re5.png"),
          list: [
            {
              name: "Title: Thor Cup Top 16 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "7",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Diamond",
              amount: "2000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "4",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "10",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "24",
            },
            {
              name: "Crest of Moon",
              amount: "2",
            },
            {
              name: "King Statue Chest",
              amount: "2",
            },
          ],
        },
        {
          name: "17~32",
          image: require("@/assets/en-re6.png"),
          imageM: require("@/assets/mobile/en-re6.png"),
          list: [
            {
              name: "Title: Thor Cup Top 32 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "5",
            },
            {
              name: "Nyan Berry",
              amount: "1500",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "2",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "5",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "20",
            },
            {
              name: "Crest of Moon",
              amount: "1",
            },
            {
              name: "Diamond",
              amount: "1500",
            },
          ],
        },
      ],
    },
    {
      type: "Babak Kualifikasi",
      item: [
        {
          name: "Tim 4 \nBesar",
          image: require("@/assets/en-re7.png"),
          imageM: require("@/assets/mobile/en-re7.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "40",
            },
            {
              name: "Nyan Berry",
              amount: "2500",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "3",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "30",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "50",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "15",
            },

            {
              name: "Diamond",
              amount: "2500",
            },
          ],
        },
        {
          name: "Tim \nke-5~8",
          image: require("@/assets/en-re8.png"),
          imageM: require("@/assets/mobile/en-re8.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "35",
            },
            {
              name: "Nyan Berry",
              amount: "2300",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "3",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "25",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "45",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "13",
            },

            {
              name: "Diamond",
              amount: "2300",
            },
          ],
        },
        {
          name: "Tim \nke-9~16",
          image: require("@/assets/en-re9.png"),
          imageM: require("@/assets/mobile/en-re9.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "33",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "3",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "20",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "40",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "12",
            },

            {
              name: "Diamond",
              amount: "2000",
            },
          ],
        },
        {
          name: "Tim \nke-17~32",
          image: require("@/assets/en-re10.png"),
          imageM: require("@/assets/mobile/en-re10.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "30",
            },
            {
              name: "Nyan Berry",
              amount: "1900",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "3",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "19",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "38",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "11",
            },

            {
              name: "Diamond",
              amount: "1900",
            },
          ],
        },
        {
          name: "Tim yang tereliminasi",
          image: require("@/assets/en-re11.png"),
          imageM: require("@/assets/mobile/en-re11.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "28",
            },
            {
              name: "Nyan Berry",
              amount: "1800",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "2",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "18",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "36",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "10",
            },

            {
              name: "Diamond",
              amount: "1800",
            },
          ],
        },
        {
          name: "Hadiah \nPartisipasi",
          image: require("@/assets/en-re12.png"),
          imageM: require("@/assets/mobile/en-re12.png"),
          list: [
            {
              name: "Diamond",
              amount: "100",
            },
            {
              name: "Mark of Prowess",
              amount: "200",
            },
            {
              name: "Random Rare Sigil Gift Box",
              amount: "1",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "5",
            },
            {
              name: "Super Cookie",
              amount: "5",
            },
            {
              name: "Purple Feather Opt. Box",
              amount: "10",
            },
          ],
        },
      ],
    },
  ],
  dia: {
    txt1: "Gift Code",
    txt2: "Copy",
    txt3: "Copy successfully",
  },
};
